import { BlockedPlaceTripOptions } from '../../lib/types/models/blocked-place/blocked-place'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getBlockedPlaceTripOptions(centerId: number, journeyId: number) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.blockedPlaces.getTripOptions.url, { id: centerId }), {
        journeyId
      })
    )
    .get<BlockedPlaceTripOptions>()
}
